<template>
  <v-layout row justify-center align-center>
    <v-layout justify-center>
      <v-btn
        class="table-btn mr-1"
        small
        icon
        @click="$emit('open-table')"
      >
        Table
      </v-btn>
      <v-btn
        v-if="hasInsidePlanButton"
        class="table-btn ml-1"
        small
        icon
        @click="$emit('switch-visible-data')"
        :disabled="false"
      >
        {{ $t(visibleDataButtonLabel) }}
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "ClosureFormSplicingTabToolbar",

  props: {
    loading: Boolean,

    disabled: Boolean,

    visibleData: String,

    hasInsidePlanButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    visibleDataButtonLabel() {
      return this.visibleData === 'splicing' ? 'Physical' : 'Logical'
    }
  }
};
</script>
<style scoped>
.table-btn{
  width: 80px !important;
  height: 100% !important;
  background-color: white;
  border-radius: 10px;
  padding: 8px 14px;
  text-transform: unset !important;
  box-shadow: 0.2px 1px 2px rgb(142, 139, 139);
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Splicing/Toolbar.vue